/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyFuelCardSerializer,
    ReadOnlyFuelCardSerializerFromJSON,
    ReadOnlyFuelCardSerializerFromJSONTyped,
    ReadOnlyFuelCardSerializerToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20015
 */
export interface InlineResponse20015 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20015
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20015
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20015
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyFuelCardSerializer>}
     * @memberof InlineResponse20015
     */
    results: Array<ReadOnlyFuelCardSerializer>;
}

export function InlineResponse20015FromJSON(json: any): InlineResponse20015 {
    return InlineResponse20015FromJSONTyped(json, false);
}

export function InlineResponse20015FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20015 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyFuelCardSerializerFromJSON)),
    };
}

export function InlineResponse20015ToJSON(value?: InlineResponse20015 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyFuelCardSerializerToJSON)),
    };
}


